import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import SearchableDropdown from "../../Components/SearchableDropdown";
import { getUserFaith, updateUserFaith } from "../../Services/subscription";
import "./FaithBeliefSettings.css";

const FaithBeliefSettings = forwardRef(function FaithBeliefSettings({ onClose, onLoadingChange }, ref) {
  const [selectedFaith, setSelectedFaith] = useState("");
  const [toggleState, setToggleState] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  useEffect(() => {
    let mounted = true;
    const init = async () => {
      try {
        const res = await getUserFaith();
        const payload = res?.payload ?? res;
        if (!mounted) return;
        if (payload?.faith) setSelectedFaith(payload.faith);
        if (payload?.toggle_state != null) setToggleState(payload.toggle_state);
      } catch (e) {
        // Not critical for initial load
      }
    };
    init();
    return () => { mounted = false; };
  }, []);

  const handleSave = async () => {
    setError("");
    setSuccess("");

    if (!selectedFaith) {
      setError("Please select your faith tradition.");
      return;
    }

    setLoading(true);
    if (typeof onLoadingChange === "function") onLoadingChange(true);
    try {
      const response = await updateUserFaith({ faith: selectedFaith, toggle_state: toggleState });
      setSuccess("Saved successfully.");
      // Auto-close after a short delay to let the success message be visible
      setTimeout(() => { onClose?.(); }, 400);
      return response;
    } catch (e) {
      setError(e?.response?.data?.message || e?.message || "Failed to save.");
    } finally {
      setLoading(false);
      if (typeof onLoadingChange === "function") onLoadingChange(false);
    }
  };

  useImperativeHandle(ref, () => ({
    save: handleSave,
  }));

  return (
    <div className="faith-dialog">
      <div className="faith-dialog__dropdown">
        <SearchableDropdown
          onBoarding={true}
          setSelectedFaith={setSelectedFaith}
          isFullWidth={true}
        />
      </div>

      <div className="faith-dialog__description">
        <p>Enhance your Aris experience with personalized, faith-aligned sessions</p>
        <ul className="faith-dialog__list">
          <li>Tailored guidance informed by your beliefs and traditions</li>
          <li>Seamless integration of spiritual teachings into every interaction</li>
        </ul>
      </div>

      {error && (
        <div className="faith-dialog__alert faith-dialog__alert--error" role="alert">
          {error}
        </div>
      )}
      {success && (
        <div className="faith-dialog__alert faith-dialog__alert--success" role="status">
          {success}
        </div>
      )}
    </div>
  );
});

export default FaithBeliefSettings;
